<template>
<section id="register-thank-you" class="flex flex-column text-center mt-5">
  <p>Congratulations! Your account has been successfully created.</p>
  <p>To activate your account, please check your email for the verification link. Once you verify your email, your account will be fully activated.</p>
</section>
</template>

<script setup lang="ts">
</script>